import React from 'react';
import { colors } from '../../DesignSystem/colors';
import { Icons } from '../../Icons/Icons';
import ImpIcon from './ImpIcon';
function ImpNavIcon({ stroke = colors.content.onSurface, ...props }) {
    return (React.createElement(ImpIcon, { padding: "12px", strokeWidth: "2px", stroke: stroke, ...props }));
}
function ImpNavIconClose({ ...props }) {
    return React.createElement(ImpNavIcon, { dataTestId: "close", iconSrc: Icons.close, ...props });
}
function ImpNavIconBack({ ...props }) {
    return (React.createElement(ImpNavIcon, { dataTestId: "back", iconSrc: Icons.chevronLeft, ...props }));
}
ImpNavIcon.Close = ImpNavIconClose;
ImpNavIcon.Back = ImpNavIconBack;
export default ImpNavIcon;
//# sourceMappingURL=ImpNavIcon.js.map